export default __webpack_public_path__ + "static/char-thumb-sp03-3ef7726413451b50f7c11faa98e41d6d.png";